/* Collection switching; cart forms use Horizon's existing product-form component. */
(() => {
  if (customElements.get('woodlas-product-edit')) return;
  customElements.define('woodlas-product-edit', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.tabs = [...this.querySelectorAll('[data-edit-tab]')];
      this.panels = [...this.querySelectorAll('[data-edit-panel]')];
      this.querySelector('[data-edit-tabs]')?.setAttribute('role', 'tablist');
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', tab.dataset.editTab);
        const panel = this.panels.find(p => p.id === tab.dataset.editTab);
        panel?.setAttribute('role', 'tabpanel');
        panel?.setAttribute('aria-labelledby', tab.id);
        panel?.setAttribute('tabindex', '0');
        tab.addEventListener('click', (event) => { event.preventDefault(); this.select(index); }, { signal });
        tab.addEventListener('keydown', (event) => {
          let target;
          if (event.key === 'ArrowRight') target = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') target = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = this.tabs.length - 1;
          if (target !== undefined) { event.preventDefault(); this.select(target); this.tabs[target].focus(); }
        }, { signal });
      });
      document.addEventListener('shopify:block:select', event => {
        const index = this.tabs.findIndex(tab => tab.dataset.blockId === event.detail?.blockId);
        if (index !== -1) this.select(index);
      }, { signal });
      this.select(0);
    }
    select(index) {
      const selected = this.tabs[index];
      if (!selected) return;
      this.tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
      this.panels.forEach(panel => { panel.hidden = panel.id !== selected.dataset.editTab; });
      const link = this.querySelector('[data-edit-view-all]');
      if (link) link.href = selected.href;
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
})();
